/*
ge-control-group-tooltip-directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('geControlGroupTooltip',['angular'], function() {
    'use strict';

    /**
     * @ngdoc directive
     * @name controlgroup.directives.geControlGroupTooltip
     * @restrict A
     *
     * @description This directive represents a custom tooltip specific to control group directive
     */
    angular.module('Directives.geControlGroupTooltip', [])
        .directive('geControlGroupTooltip', ['$window', function($window) {

            var CONTROL_GROUP_TOOLTIP = 'control-group-tooltip';
            var TOOLTIP_CONTAINER_ID = 'control-group-tooltip-container';

            function link(scope, element, attrs) {
                attrs.$observe('geControlGroupTooltipText', function(newValue, oldValue) {
                    if (newValue !== oldValue && newValue !== undefined) {
                        removeListeners(element);
                        $(element).on('mouseover', {
                            text: attrs.geControlGroupTooltipText
                        }, mouseOverHandler);
                        $(element).on('mouseleave', mouseLeaveHandler);
                    }
                });
            }

            function removeListeners(element) {
                $(element).off('mouseover mouseleave');
            }

            function mouseOverHandler(event) {
                if (!event.data.text) {
                    event.stopPropagation();
                    return;
                }
                var tooltip = $('<div id="' + $(event.target).attr('id') + '-tooltip" class="tooltip right in">' + '<div class="tooltip-arrow"></div><div class="tooltip-inner">' + event.data.text + '</div>' + '</div>');
                var tooltipContainer = $('<div id="' + TOOLTIP_CONTAINER_ID + '"></div>');
                insertTooltipIntoDom(tooltip, tooltipContainer, $(event.target));
            }

            function mouseLeaveHandler(event) {
                getElementForTooltipContainer($(event.target)).find('#' + TOOLTIP_CONTAINER_ID).remove();
            }

            function insertTooltipIntoDom(tooltip, tooltipContainer, target) {
                tooltipContainer.appendTo(getElementForTooltipContainer(target));
                tooltip.appendTo(tooltipContainer);
                var itemPosition = target.offset();
                // Added for RTL support
                var itemPositionLeft = itemPosition.left;
                var languageDirection = $window.Messages('languageDirection');
                if (languageDirection === 'rtl') {
                    itemPositionLeft = itemPositionLeft - tooltip.width() - target.width();
                } else {
                    itemPositionLeft = itemPositionLeft + target.width();
                }
                tooltip.offset({
                    top: itemPosition.top - tooltip.height() / 2 + target.height() / 2,
                    left: itemPositionLeft
                });
            }

            function getElementForTooltipContainer(target) {
                return target.closest('.' + CONTROL_GROUP_TOOLTIP);
            }

            return {
                restrict: 'A',
                link: link
            };
        }]);
});

